<template>
  <div>
    <v-layout class="mt-2">
      <v-flex xs6>
        <BuscaSimplesApi
          style="width: 100%"
          label="Buscar"
          :disabled="acao != ''"
          route="gerencial/localexterno"
          :fieldSearch="buscarSelect"
          @found="encontrado"
          ref="buscaSimpleApi">
          <template slot-scope="propSlot">
            <span>{{ textoBuscaApi(propSlot.item) }}</span>
          </template>
        </BuscaSimplesApi>
      </v-flex>
      <v-flex xs4 class="ml-3">
        <Select :options="buscaOptions" v-model="buscarSelect" label="" @change="selectBuscaChange"/>
      </v-flex>
    </v-layout>



    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <FormBasico
      :submit="onSubmit"
      :acao="acao"
      :novo="novoLocalExterno"
      :editar="editarLocalExterno"
      :excluir="excluirLocalExterno"
      :cancelar="cancelarLocalExterno"
      :id="form.identificadorlocalexterno"
      class="mb-3">
        <!-- *******  -->
      <v-tabs>
        <v-tabs-slider color="#fff"></v-tabs-slider>
        <v-tab @click="tabelaLocalExterno">
          <v-icon left color="#757575">view_list</v-icon>
        </v-tab>
      </v-tabs>
    <!-- *******  -->

          <v-card class="pa-3">
            <Input type="text" label="Código Local Externo" disabled v-model="form.identificadorlocalexterno" />
            <Input type="text" label="Nome Local Externo" :disabled="desabilitarCampos()" ref="focusCampo" v-model="form.nomelocalexterno" :v="$v.form.nomelocalexterno"/>
            <InputMask mask="##.###.###/####-##" label="CNPJ Local Externo" :disabled="desabilitarCampos()" v-model="form.numerocnpj" :v="$v.form.numerocnpj"/>
            <Endereco
              :acao="acao"
              :numero.sync="form.numeroimovel"
              :complemento.sync="form.descricaocomplementoendereco"
              :codigologradouro.sync="form.codigologradouro"
              :validation="validacaoEndereco()"
              :desabilitar="form.indicanacionalidadeescola == 'I' || (acao == 'editar' && form.tiposituacaofuncionamento == '3')"
              :vNumero="$v.form.numeroimovel"
              :vComplemento="$v.form.descricaocomplementoendereco" />
            <InputMask :mask="['(##) ####-####', '(##) #####-####']" label="Telefone" :disabled="desabilitarCampos()" v-model="form.numerotelefone" :v="$v.form.numerotelefone"/>
            <Input type="number" label="Ramal do Local Externo" :disabled="desabilitarCampos()" max="9999" v-model="form.numeroramal" :v="$v.form.numeroramal"/>
            <Input type="text" label="E-mail Oficial" :disabled="desabilitarCampos()" v-model="form.descricaoemailoficial" :v="$v.form.descricaoemailoficial"/>
            <Validator label="Local Externo está sendo utilizado?" :v="$v.form.indicalocalexternosendoutilizado">
              <Radio v-model="form.indicalocalexternosendoutilizado" val="S" :disabled="desabilitarCampos()" @blur="$v.form.indicalocalexternosendoutilizado.$touch()" label="Sim"/>
              <Radio v-model="form.indicalocalexternosendoutilizado" val="N" :disabled="desabilitarCampos()" @blur="$v.form.indicalocalexternosendoutilizado.$touch()" label="Não"/>
            </Validator>
            <Input type="time" :disabled="desabilitarCampos()" v-model="form.horariofuncionamentoinicio" label="Horário de Funcionamento Início"/>
            <Input type="time" :disabled="desabilitarCampos()" v-model="form.horariofuncionamentofim" label="Horário de Funcionamento Fim"/>

            <Input type="text" disabled v-model="form.latitude" readonly label="Latitude" />
            <Input type="text" disabled v-model="form.longitude" readonly label="Longitude" />


          </v-card>
    </FormBasico>
    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import api from '@/api';
import {validaCnpj} from '@/utils/validaCnpj';
import Endereco from '@/components/Endereco';
import BuscaSimplesApi from '@/components/BuscaSimplesApi';
import {
  required, maxLength, minLength, alpha, integer, email, between, alphaNum,
} from 'vuelidate/lib/validators';
import { alphaSpace } from '@/validations';

const setFormInicial = () => ({
  identificadorlocalexterno: '',
  codigologradouro: '',
  nomelocalexterno: '',
  numerocnpj: '',
  numeroimovel: '',
  descricaocomplementoendereco: '',
  descricaoemailoficial: '',
  horariofuncionamentofim: '',
  horariofuncionamentoinicio: '',
  numeroramal: '',
  numerotelefone: '',
  latitude: '',
  longitude: '',
});

export default {
  name: 'localexterno',
  components: {
    Endereco,
    BuscaSimplesApi,
  },
  data() {
    return {
      acao: '',
      form: setFormInicial(),
      msgError: '',
      msgArrayError: [],
      snackbar: false,
      submitText: '',
      formUltimo: {},
      buscarSelect: 'nomelocalexterno',
      buscaOptions: [
        { value: 'identificadorlocalexterno', text: 'Código Local Externo' },
        { value: 'nomelocalexterno', text: 'Nome Local Externo' },
      ],
    };
  },
  validations() {
    return {
      form: {
        codigologradouro: { required },
        nomelocalexterno: {
          required, maxLength: maxLength(100), alphaSpace, minLength: minLength(4),
        },
        numerocnpj: { maxLength: maxLength(14),
                     validaCnpj,
                     },
        numeroimovel: { maxLength: maxLength(10), integer, required },
        descricaocomplementoendereco: { maxLength: maxLength(20) },
        descricaoemailoficial: { email, maxLength: maxLength(50) },
        numeroramal: { maxLength: maxLength(4), integer },
        numerotelefone: { maxLength: maxLength(11), minLength: minLength(10) },
        descricaocomplementoendereco: { maxLength: maxLength(50) },
      },
    };
  },
  methods: {

    tabelaLocalExterno(){
      this.$root.$router.push({
          name: 'tabelas',
          params: {
            titulo: 'Local Externo / Listar',
            rota_api: 'gerencial/localexterno/tabela',
            headers: [{ text: 'Identificador', value: 'identificadorlocalexterno', filtable: true, sortable: false},
						          { text: 'Descrição', value: 'nomelocalexterno', filtable: true, sortable: false}]
          }
      });
    },
    novoLocalExterno() {
      this.acao = 'novo';
      this.form = setFormInicial();
      this.form = {
        ...this.form,
      };
      this.$v.$reset();
      setTimeout(() => this.$refs.focusCampo.$refs.input.focus(), 200);
    },
    editarLocalExterno() {
      if (this.form.identificadorlocalexterno !== '') {
        this.acao = 'editar';
      }
    },
    async excluirLocalExterno() {
      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir este local externo?',
        type: 'warning',
        buttons: [
          { text: 'Excluir', color: 'red', response: true },
          { text: 'Cancelar', color: 'grey', response: false },
        ],
      });

      if (confirmar) {
        try {
          const { data } = await api.delete(`gerencial/localexterno/${this.form.identificadorlocalexterno}`);

          this.acao = '';
          this.submitText = data.message;
          this.snackbar = true;
          this.form = setFormInicial();
          this.msgArrayError = [];
        } catch (error) {
          const ntfExcluir = await this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }
    },
    cancelarLocalExterno() {
      if (this.acao === 'novo') {
        this.form = setFormInicial();
      } else {
        this.form = { ...this.formUltimo };
      }
      this.acao = '';
      this.msgArrayError = [];
      this.$v.$reset();
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
        return;
      }

      try {
        const response = await api({
          method: (this.acao === 'novo') ? 'post' : 'put',
          url: `gerencial/localexterno${(this.acao === 'novo') ? '' : `/${this.form.identificadorlocalexterno}`}`,
          data: this.form,
        });

        this.acao = '';
        this.submitText = response.data.message;
        this.snackbar = true;
        this.msgArrayError = [];

        if (this.acao == '') { this.form = { ...response.data.results }; }
      } catch (error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      }
      this.$v.$reset();
      return true;
    },
    encontrado(dados) {
      this.form = setFormInicial();
      this.form = {
        ...dados,
      };
      this.formUltimo = { ...this.form };
      this.$refs.buscaSimpleApi.lista = [];
    },
    validacaoEndereco() {
      return (this.$v.form.codigologradouro.$invalid && this.$v.form.codigologradouro.$dirty);
    },
    desabilitarCampos() {
      return (this.acao == 'editar') ? (this.acao == '' ) : this.acao == '';
    },
    selectBuscaChange() {
      this.$refs.buscaSimpleApi.busca = '';
    },
    textoBuscaApi(dados) {
      let nomeCidade = '';
      return `${dados.nomelocalexterno} - ${dados.tipologradouro} ${dados.nomelogradouro},
       ${dados.numeroimovel}
       ${(dados.descricaocomplementoendereco)? ', COMPLEMENTO: '+dados.descricaocomplementoendereco : ''}
      , BAIRRO ${dados.nomebairro} - ${dados.nomecidade}`;
    },
  },
};
</script>

<style lang="scss">
.escola-card-dados{
  display: block;
  padding: 10px 16px;

  &> div {
    margin: 3px 0px;
  }

  .escola-card-dados-itens{
    display: flex;
    flex-wrap: wrap;
    div{
      margin-right: 7%;
      white-space: nowrap;
    }
  }
}
</style>
